import { DataServiceService } from '../configuration/services/data-service.service';
import { FeatureFlagsFacadeService } from '../services/feature-flags-facade.service';
import { DataDogService } from './datadog/services/data-dog.service';
import { TokenCleanupService } from './services/token-cleanup.service';

export function appInitialize(
  tokenCleanupService: TokenCleanupService,
  dataService: DataServiceService,
  dataDogService: DataDogService,
  featureFlagsFacadeService: FeatureFlagsFacadeService
) {
  return async () => {
    try {
      tokenCleanupService.removeTokenFromHistory();

      await featureFlagsFacadeService.loadFeatureFlags();

      await dataService.getConfiguration();

      dataDogService.initRUM();
      dataDogService.initLogs();
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
}
